<!--Banner start-->
<div class="partner-banner">
    <div class="container">
        <div class="row">
            <div class="col-12">

                <h1 class="accessibility-plugin-ac ">{{'PARTNER.Become a cowin partner'| translate}}</h1>

                <a  class="btn btn-white accessibility-plugin-ac" href="https://sandbox.ndhm.gov.in/applications/cowin/Home/cowin_signup_form" target="_blank" aria-label="Register Now">{{'PARTNER.RegisterNow'| translate}}</a>

            </div>
        </div>
    </div>


</div>
<!--Banner end-->

<!--Integration section start-->
<div class="page-wrap Integration-section">
    <div class="container">
        <div class="top_heading text-center">
            <h2 class=" accessibility-plugin-ac main-heading mb-lg-4">{{'PARTNER.Co-WIN API Integration'| translate}}</h2>
        <p  class="accessibility-plugin-ac">{{'PARTNER.How it works?' | translate}}</p>
        </div>
        <div class="clearfix"></div>
        <div class="row mt-70">
            <div class="col-md-2 int-box arrow-right">

                <div class="bottom-text ">
                    <img src="../../../assets/images/apply-online-new.svg"   alt="Image">
                 <p class=" accessibility-plugin-ac" >{{'PARTNER.Apply Online' | translate}}</p>
                </div>
            </div>
            <div class="col-md-2 int-box arrow-right">

                <div class="bottom-text ">
                    <img src="../../../assets/images/get-api-key-new.svg"  alt="Image">
                 <p class=" accessibility-plugin-ac">{{'PARTNER.Get API Key' | translate}}</p>
                </div>
            </div>
            <div class="col-md-2 int-box arrow-right">

                <div class="bottom-text ">
                    <img src="../../../assets/images/develop-host-new.svg"  alt="Image">
                 <p class=" accessibility-plugin-ac" [innerHTML]="'PARTNER.Develop Host APIs'| translate"></p>
                </div>
            </div>
            <div class="col-md-2 int-box arrow-right">

                <div class="bottom-text ">
                    <img src="../../../assets/images/integrate-with-cowin-new.svg"  alt="Image" >
                 <p class=" accessibility-plugin-ac" [innerHTML]="'PARTNER.Integrate with Co-WIN'| translate"></p>
                </div>
            </div>
            <div class="col-md-2 int-box arrow-right">

                <div class="bottom-text ">
                    <img src="../../../assets/images/testing-audit-new.svg"  alt="Image" >
                 <p class=" accessibility-plugin-ac" [innerHTML]="'PARTNER.Perform Testing/Audit'| translate"></p>
                </div>
            </div>
            <div class="col-md-2 int-box ">

                <div class="bottom-text ">
                    <img src="../../../assets/images/go_live_new.svg"  alt="Image">
                 <p class=" accessibility-plugin-ac">{{'PARTNER.Go Live' | translate}}</p>
                </div>
            </div>
        </div>

    </div>


</div>
<!--Integration section end-->
<!--API section start-->
<div class="page-wrap api-section  text-center">
    <div class="container">
        <h2 class=" accessibility-plugin-ac main-heading mb-5">{{'PARTNER.Discover Our Open APIs' | translate}}</h2>
        <a  class="btn btn-white accessibility-plugin-ac" href="https://apisetu.gov.in/public/marketplace/api/cowin" target="_blank" aria-label="Check our API Setu">{{'PARTNER.Checkout on API Setu' | translate}}</a>
    </div>
    </div>

    <!--API section end-->
<!--cms section start-->
<div class="page-wrap cms-section">
    <div class="container">
        <div class="row ">
            <div class="col-md-6 d-flex  flex-column justify-content-center align-items-center  align-items-md-start mb-5 mb-md-0 mb-lg-0 md-sm-0">
                <h3 class=" accessibility-plugin-ac">No Code Integration <span>Using Headless Form</span> </h3>
                <a  href="../../../assets/images/20211012_eKYVS.pdf" target="_blank" aria-label="Know More" class="btn btn-white accessibility-plugin-ac">Know More</a>
            </div>
            <div class="col-md-6">
                <img src="../../../assets/images/code-integration-illustration.svg" alt="image" class="img-fluid">
            </div>
        </div>
    </div>

</div>
<!--cms section end-->



<!--partner section start-->
<div class="page-wrap all-partner mb-4">
    <div class="top_heading text-center">
        <div class="container">
            <h2 class=" accessibility-plugin-ac text-center main-heading mb-0">{{'HOME.Our_PARTNERS' | translate}}</h2>
        </div>

    </div>
    <div class="container">



       <div class="row text-center">
           <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
               <div class="modal-logo">
            <img src="../../../assets/images/digiLocker_logo.svg"  class="img-fluid" alt="image">

        </div>



           </div>

           <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
            <img src="../../../assets/images/aarogya-setu-logo-png-free-download-11597263051zbxpc7jmy1.svg"  class="img-fluid" alt="image">

            </div>


           </div>

           <div class=" col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
            <img src="../../../assets/images/Umang.svg" class="img-fluid" alt="image" >

            </div>


           </div>

           <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
            <img src="../../../assets/images/mygov-logo.svg" class="img-fluid" alt="image">

            </div>


           </div>

           <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
         <img src="../../../assets/images/jio.svg" class="img-fluid" alt="image">

     </div>



        </div>

        <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
         <div class="modal-logo">
         <img src="../../../assets/images/Step one.svg" class="img-fluid" alt="image">

         </div>


        </div>

        <!-- <div class=" col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
         <div class="modal-logo">
         <img src="../../../assets/images/one-97-communications-removebg.svg" class="img-fluid" alt="image">

         </div>


        </div> -->
        <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
            <img src="../../../assets/images/trigyn-logo.svg" class="img-fluid trigyn-logo" alt="Trigyn">
            </div>
           </div>

        <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
         <div class="modal-logo">
         <img src="../../../assets/images/Bajaj_Finserv_Health.svg" class="img-fluid" alt="My Gov">

         </div>


        </div>

        <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
         <img src="../../../assets/images/xiScieniq Software India Private Limited.svg" class="img-fluid" alt="image">

     </div>



        </div>

        <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
         <div class="modal-logo">
         <img src="../../../assets/images/whatsapp.svg" class="img-fluid" alt="image">

         </div>


        </div>

        <div class=" col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
         <div class="modal-logo">
         <img src="../../../assets/images/MRE Services India.com Private Limited.svg" class="img-fluid" alt="image">

         </div>


        </div>

        <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
         <div class="modal-logo">
         <img src="../../../assets/images/Apollo.svg" class="img-fluid" alt="image">

         </div>


        </div>


        <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
            <img src="../../../assets/images/health-family-welfare-department.svg" class="img-fluid" alt="image">

            </div>


           </div>
           <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
            <img src="../../../assets/images/Spice Money Limited.svg" class="img-fluid" alt="image">

            </div>


           </div>
           <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
            <img src="../../../assets/images/SWASTH Arogya.svg" class="img-fluid" alt="image">

            </div>


           </div>
           <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
            <img src="../../../assets/images/National Health Mission, Karnataka.svg" class="img-fluid" alt="image">

            </div>


           </div>
           <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
            <img src="../../../assets/images/IMPULSE.svg" class="img-fluid" alt="image">

            </div>


           </div>
           <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
            <img src="../../../assets/images/Indian Institute of Technology Bombay.svg" class="img-fluid" alt="image">

            </div>


           </div>
           <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
            <img src="../../../assets/images/Anaxee Digital Runners Private Limited.svg" class="img-fluid" alt="image">

            </div>


           </div>
           <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
            <img src="../../../assets/images/Haqdarshak.svg" class="img-fluid" alt="image">

            </div>


           </div>
           <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
            <img src="../../../assets/images/InnoHealth.svg" class="img-fluid" alt="image">

            </div>


           </div>
           <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
            <img src="../../../assets/images/BUY NSWIPE.svg" class="img-fluid" alt="image">

            </div>


           </div>

           <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
            <img src="../../../assets/images/csc-academy.svg" class="img-fluid" alt="image">

            </div>


           </div>


           <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
            <img src="../../../assets/images/Gig labs.svg" class="img-fluid" alt="image">

            </div>


           </div>


           <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
            <img src="../../../assets/images/Connect & heal.svg" class="img-fluid" alt="image">

            </div>


           </div>

           <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
            <img src="../../../assets/images/PAYTM.svg" class="img-fluid" alt="image">

            </div>


           </div>

           <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
            <!-- <img src="../../../assets/images/orbiHEALTH PRIVATE LIMITED.svg" class="img-fluid" alt="image"> -->
<div class="noLogoPlaceholder  mx-auto mb-2 my-auto"><p class="placholderbox nologo">NO LOGO AVAILABLE</p><p>Orbi Health Private Limited</p></div>
           </div>
            </div>


           <div class="col-lg-2 col-md-4 col-sm-6 pr-lg-0 col-6 ">
            <div class="modal-logo">
            <img src="../../../assets/images/MicrosoftTeams-image (1).svg" class="img-fluid" alt="image">

            </div>


           </div>








       </div>




    </div>
</div>
<!--partner section end-->

















